import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { recordNavigationPath } from '@/lib/lark-error-nav';

/** Paths only. Mount inside the router. */
export function LarkErrorNavTracker() {
  const location = useLocation();
  useEffect(() => {
    recordNavigationPath(location.pathname);
  }, [location.pathname]);
  return null;
}
